import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Quiz from './Quiz'
import Image from '../image';
import { Button, Grow, Grid, Typography, Avatar, Tooltip } from '@material-ui/core'
import { ChevronLeft, ChevronRight, CheckCircleOutline } from '@material-ui/icons'
import { ClockLoader, MoonLoader } from "react-spinners";
import { CircularProgressbarWithChildren as CircularProgressbar } from 'react-circular-progressbar';
import { useSnackbar } from 'notistack';
import ProgressProvider from '../progressProvider';

import chars from '../../data/characters.json';

const doProcess = async (ans, tries, currAnswer, setLoading, setData, setTries, notif) => {
  if (currAnswer <= 0 || currAnswer > 6) {
    notif("You must choose an option", { variant: 'warning' });
    return;
  }
  if (tries > 3) {
    notif("You've tried more than 3 times", { variant: "warning" });
    notif("Come back just a few seconds later", { variant: "default" });
    if (tries === 4) {
      setTimeout(() => {
        setTries(0);
      }, 5000);
    }
    return;
  }
  notif("Please wait ...", { variant: "info" });
  setLoading(true);
  const scrollInterval = setInterval(() => {
    const loading = document.getElementById("loading");
    if(loading){
      clearInterval(scrollInterval);      
      window.scrollTo(0, loading.offsetTop);
    }
  }, 10);
  if (typeof (window) !== undefined) {
    const formData = new FormData();
    formData.append("answers", ans);
    const fsAPI = window.qAPI;
    try {
      const res = await fetch(fsAPI, { method: "POST", credentials: "same-origin", body: formData })
      const resJSON = await res.json();
      const { message, result, status } = resJSON;      
      if (status.code === 200) {
        result.result = (result.result || []).map((r, idx) => ({ similarity: Math.round(r*10000)/100, ...chars[idx] })).sort((a, b) => b.similarity - a.similarity);
        setData(result);
        setTries((tries) => tries > 4 ? tries : tries + 1);
        notif("Processed Successfully", { variant: "success" });
      }
      else {
        (message || []).forEach((msg) => {
          notif(msg, { variant: "error" });
        });
      }
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
      notif("Something went wrong!", { variant: "error" });
      notif("Try again later", { variant: "default" });
    }
    finally {
      return;
    }
  }
  notif("No API FOUND!", { variant: "error" });
}

const handleNav = (dir, currQ, setCurrQ, dataLength, currAnswer, notif) => {
  if (dir !== "left" && (currAnswer <= 0 || currAnswer > 6)) {
    notif("You must choose an option", { variant: 'warning' });
    return;
  }
  switch (dir) {
    case 'left':
      if (currQ > 0) setCurrQ(currQ - 1)
      break;
    case 'right':
      if (currQ < dataLength - 1) setCurrQ(currQ + 1)
      break;
    default:
      break;
  }
}

const setAnswer = (answers, setAnswers, quizNumber, selectedAnswer) => {
  const tmp = answers.map((a) => a);
  tmp[quizNumber - 1] = selectedAnswer;
  setAnswers(tmp);
}

function QuizWrapper(props) {
  const [currQ, setCurrQ] = useState(0);
  const [answers, setAnswers] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [tries, setTries] = useState(0);
  const { enqueueSnackbar: notif } = useSnackbar();
  const { data = [] } = props;
  const {result: results} = result||{};
  

  const renderQuest = () => (
    <>
      <div className="nav-btns">
        <Button disabled={currQ === 0} color="secondary" variant="outlined" onClick={() => handleNav("left", currQ, setCurrQ, data.length, answers[currQ], notif)}><ChevronLeft /> Prev</Button>
        {
          currQ !== data.length - 1 &&
          <Button color="secondary" variant="outlined" onClick={() => handleNav("right", currQ, setCurrQ, data.length, answers[currQ], notif)}>Next <ChevronRight /></Button>
        }
        {
          currQ === data.length - 1 &&
          <Button color="primary" variant="contained" onClick={() => doProcess(answers, tries, answers[currQ], setLoading, setResult, setTries, notif)}>Finish&nbsp;<CheckCircleOutline /></Button>
        }
      </div>
      <div>
        {
          data.map((q, idx) => (
            <Grow key={`quiz-number-${idx + 1}`} in={idx === currQ}>
              <div>
                <div style={{ position: idx !== currQ ? "absolute" : "relative", zIndex: idx !== currQ ? "-9999" : idx + 1, opacity: idx !== currQ ? 0 : 1, transition: "opacity 300ms ease-in-out" }}>
                  <Quiz data={q} quizNumber={idx + 1} answer={answers[idx]} setAnswer={(qNum, selAns) => setAnswer(answers, setAnswers, qNum, selAns)} />
                </div>
              </div>
            </Grow>
          ))
        }
      </div>
      <div className="nav-btns">
        <Button disabled={currQ === 0} color="secondary" variant="outlined" onClick={() => handleNav("left", currQ, setCurrQ, data.length, answers[currQ], notif)}><ChevronLeft /> Prev</Button>
        {
          currQ !== data.length - 1 &&
          <Button color="secondary" variant="outlined" onClick={() => handleNav("right", currQ, setCurrQ, data.length, answers[currQ], notif)}>Next <ChevronRight /></Button>
        }
        {
          currQ === data.length - 1 &&
          <Button color="primary" variant="contained" onClick={() => doProcess(answers, tries, answers[currQ], setLoading, setResult, setTries, notif)}>Finish&nbsp;<CheckCircleOutline /></Button>
        }
      </div>
    </>
  );

  const renderLoading = () => (
    <div id="loading" className="loading">
      <ClockLoader
        color="#C11B1F"
        size={250}
        loading
      />
      <div className="running">
        <MoonLoader size={20} />
        <h3 style={{textAlign: "center"}}>Running On Server</h3>
        <MoonLoader size={20} />
      </div>
      <Typography variant="h6">Please Wait</Typography>
      <Typography variant="subtitle1">It might take a minute or two</Typography>
    </div>
  )

  const renderResult = () => (
    <div className="result">
      <Button
        fullWidth
        color="secondary"
        variant="outlined"
        onClick={() => {setResult(null); setCurrQ(0); setAnswers([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])}}
      >
        Try Another One
      </Button>
      <br />
      <br />
      <Typography variant="subtitle1">
        The results show your likeness with each character <b>separately</b>
    </Typography>
      <br />
      <Grid justify="center" container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={11} xl={10}>
          <div className="first">
            <ProgressProvider valueStart={0} valueEnd={results[0].similarity}>
              {
                (value) => (
                  <CircularProgressbar className="result-circle" strokeWidth={4} background backgroundPadding={2} value={value} maxValue={100}>
                    <Tooltip title={results[0].name} arrow placement="top">
                      <Avatar className="avatar">
                        <Image name={results[0].avatar} style={{ width: "100%", height: "100%" }} />
                      </Avatar>
                    </Tooltip>
                  </CircularProgressbar>
                )
              }
            </ProgressProvider>
            <Typography variant="h4">{Math.round(results[0].similarity)}%</Typography>
          </div>
          <div className="others">
            <Grid container spacing={2} justify="center">
              {
                (results.slice(1)).map((res) => (
                  <Grid key={res.name} item xs={6} sm={3} md={2}>
                    <ProgressProvider valueStart={0} valueEnd={res.similarity}>
                      {
                        (value) => (

                          <CircularProgressbar className="result-circle" strokeWidth={4} background backgroundPadding={2} value={value} maxValue={100}>
                            <Tooltip title={res.name} arrow placement="top">
                              <Avatar className="avatar">
                                <Image name={res.avatar} style={{ width: "100%", height: "100%" }} />
                              </Avatar>
                            </Tooltip>
                          </CircularProgressbar>
                        )
                      }
                    </ProgressProvider>
                    <Typography variant="h5">{Math.round(res.similarity)}%</Typography>
                  </Grid>
                ))
              }
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  )

  return (
    <div id="QuizWrapper">
      {!loading && !result && renderQuest()}
      {loading && renderLoading()}
      {!loading && result && renderResult()}
    </div>
  )
}

QuizWrapper.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    question: PropTypes.shape({
      image: PropTypes.string,
      text: PropTypes.string,
    }),
    answers: PropTypes.arrayOf(PropTypes.shape({
      image: PropTypes.string,
      sound: PropTypes.string,
      soundTitle: PropTypes.string,
      soundArtist: PropTypes.string,
      soundURL: PropTypes.string,
      text: PropTypes.string,
    }))
  })).isRequired,
  onDone: PropTypes.func,
}

QuizWrapper.defaultProps = {
  onDone: () => { },
}

export default QuizWrapper

